<p-confirmPopup></p-confirmPopup>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div *ngIf="roleName !== userRoles.SUPER_ADMIN " class="card breadcrumbs">
    <div class="common-justify-wrap card-container purple-container">
        <ul class="list-none breadcrumbs-outer">
            <li class="active-dashboard">
                <a [routerLink]="[roleName === userRoles.SUPER_ADMIN ? '/super-admin/dashboard' : '/manager/dashboard']"
                    class="common-underline">Dashboard</a>
            </li>
            <li class="px-2 breadcrumbs-divider">
                <span>|</span>
            </li>
            <li class="back-link">
                <a [routerLink]="[roleName === userRoles.SUPER_ADMIN ? '/super-admin/parking-list/'+ companyId : '/manager/parking']"
                    class="common-underline">Parking Locations</a>
            </li>
            <li class="px-2 breadcrumbs-divider">
                <span>|</span>
            </li>
            <li class="current-link">
                <span class="line-height-3">Edit Parking</span>
            </li>
        </ul>
    </div>
</div>
<div class="main-card">
    <div class="form-deatail">
        <div class="common-flex-between create-active">
            <h3>Edit Parking</h3>
            <div class="comming-soon" *ngIf="commingSoonCheckbox">
                <p-checkbox [binary]="true" [ngModel]="isComingsoonParking"
                    (ngModelChange)="comingsoonCheckbox($event)"></p-checkbox>
                <div class="comming pl-2">Coming Soon</div>
            </div>
        </div>
        <form *ngIf="!isComingsoonParking" [formGroup]="parkingForm">
            <div class="grid">
                <div class="field col-12 md:col-6 lg:col-4">
                    <div class="custom-flex-start formgrid">
                        <label for="parkingName">Parking Name <span class="custom-star">*</span></label>
                        <input pInputText placeholder="Enter Parking Name" (keydown)="preventFirstSpace($event)"
                            id="parkingName" aria-describedby="username-help" formControlName="name" />
                        <div
                            *ngIf="parkingForm.get('name')?.hasError('required')  && (parkingForm.get('name')?.dirty || parkingForm.get('name')?.touched)">
                            <div class="validation-error">This field is required*</div>
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-6 lg:col-4">
                    <div class="custom-flex-start formgrid parking-location">
                        <label for="locAddress">Parking Location <span class="custom-star">*</span></label>
                        <div class="p-inputgroup custom-location location-icon">
                            <input type="text" (keydown)="preventFirstSpace($event)" pInputText
                                placeholder="Set Location on Map" formControlName="locAddress" id="locAddress"
                                mapAutoComplete (mapSearch)="searchAutoCompleteLocation($event,'parking')" />
                            <img src="../../../../assets/images/map-location.svg"
                                (click)="openMap(parkingForm, 'locAddress', 'location')" alt="map" />
                        </div>
                        <div
                            *ngIf="parkingForm.get('locAddress')?.hasError('required')  && (parkingForm.get('locAddress')?.dirty || parkingForm.get('locAddress')?.touched)">
                            <div class="validation-error"> This field is required*</div>
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-6 lg:col-4">
                    <div class="custom-flex-start formgrid tax-income">
                        <label for="taxAndFees">Taxes </label>
                        <input id="taxAndFees" pInputText type="text" class="common-input" placeholder="Enter Taxes %"
                            formControlName="taxAndFees" (keypress)="onKeyPressAllowTwoDigitAfterPoint($event)" />
                        <div
                            *ngIf="parkingForm.get('taxAndFees')?.hasError('pattern')  && (parkingForm.get('taxAndFees')?.dirty || parkingForm.get('taxAndFees')?.touched)">
                            <div class="validation-error"> Only Digits Allowed*</div>
                        </div>
                        <div
                            *ngIf="parkingForm.get('taxAndFees')?.hasError('lessThanHundred') && (parkingForm.get('taxAndFees')?.dirty || parkingForm.get('taxAndFees')?.touched)">
                            <div class="validation-error"> Taxes cannot exceed 100%</div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="divider">
            </div>

            <div class="cedtor-outer custom-flex-start formgrid">
                <h5 class="park-heading">Parking Instructions <span class="custom-star">*</span></h5>
                <div class="park-border">
                    <div class=""></div>
                    <div class="one-timebooking">
                        <img src="assets/images/one-time-timer.svg" alt="timer" />
                        <p>One Time Bookings Instruction</p>
                    </div>
                    <div class="booking-textarea">
                        <p-editor #onetime class="oneTimeRecurring-editor" formControlName="oneTimeInstructions"
                            placeholder="Enter Description"
                            (onTextChange)="oneTimeLimitText($event, onetime, 'oneTimeInstruction')"
                            (onInit)="onEditorInit($event)" [style]="{'height':'150px'}"
                            [modules]="editorTools"></p-editor>
                        <div
                            *ngIf="parkingForm.get('oneTimeInstructions')?.hasError('required')  && (parkingForm.get('oneTimeInstructions')?.dirty || parkingForm.get('oneTimeInstructions')?.touched) && !oneTimeEditorTextLimitError && !oneTimeEditorSpaceError">
                            <div class="validation-error"> This field is required*</div>
                        </div>

                        <div *ngIf="oneTimeEditorSpaceError && !oneTimeEditorTextLimitError">
                            <div class="validation-error">Description cannot be empty or only spaces!</div>
                        </div>

                        <div *ngIf="oneTimeEditorTextLimitError">
                            <div class="validation-error">Character must not exceed 1000.
                            </div>
                        </div>
                    </div>
                    <div class="characters-outer">
                        <p>Characters: {{textLength['oneTimeInstruction'] || 0}}/1000</p>
                    </div>

                    <div class="one-timebooking">
                        <img src="assets/images/one-time-timer.svg" alt="timer" />
                        <p>Recurring Bookings Instructions</p>
                    </div>
                    <div class="booking-textarea">

                        <p-editor #recurring class="oneTimeRecurring-editor" formControlName="recurringInstructions"
                            placeholder="Enter Description"
                            (onTextChange)="recurringLimitText($event, recurring,'recurringInstruction')"
                            (onInit)="onRecurringInit($event)" [style]="{'height':'150px'}"
                            [modules]="editorTools"></p-editor>
                        <div
                            *ngIf="parkingForm.get('recurringInstructions')?.hasError('required')  && (parkingForm.get('recurringInstructions')?.dirty || parkingForm.get('recurringInstructions')?.touched) && !recurringEditorSpaceError && !recurringEditorTextLimitError">
                            <div class="validation-error"> This field is required*</div>
                        </div>

                        <div *ngIf="recurringEditorSpaceError && !recurringEditorTextLimitError">
                            <div class="validation-error">Description cannot be empty or only spaces!</div>
                        </div>

                        <div *ngIf="recurringEditorTextLimitError">
                            <div class="validation-error">Character limit 1000</div>
                        </div>
                    </div>
                    <div class="characters-outer">
                        <p>Characters: {{textLength['recurringInstruction'] || 0}}/1000</p>
                    </div>
                    <div class="upload-doc">
                        <p>Allow to upload PDF and word format</p>
                        <div class="upload-doc-iiner" (click)="fileInput.click()">
                            <span>Upload Document</span><img src="assets/images/uploaded-doc.svg" alt="Upload Icon" />
                        </div>
                        <input type="file" #fileInput (change)="onFileSelected($event)" accept=".pdf,.docx" hidden />
                    </div>
                    <div *ngIf="termsAndConditionFilePath" class="doc-close">
                        <a *ngIf="termsAndConditionFilePath" [href]="termsAndConditionFilePath" target="_blank">
                            {{uploadedFile}}
                        </a>
                        <img (click)="removeFile(fileInput)" src="assets/images/close-icon-model.svg" alt="" />
                    </div>
                </div>
            </div>

            <div class="divider">
            </div>

            <div class="create-access code">
                <h5 class="park-heading">Access Code</h5>
                <div class="access-text">
                    <h5>
                        Access code that the driver needs to use at the time of check-in or re-entry
                    </h5>
                    <p>To use the same code for one-time and monthly bookings, enter the same code</p>
                </div>
                <div class="current-accesscode">
                    <div class="inner-access">
                        <p>Current access code</p>
                        <h4
                            *ngIf="!parkingForm.get('oneTimeAccessCode')?.value && !parkingForm.get('monthlyAccessCode')?.value">
                            System Generated</h4>
                    </div>
                    <div class="one-timemain grid">
                        <div class="col-6">
                            <div class="inner-label">
                                <label for="oneTimeAccessCode">One-time access code</label>
                                <input id="oneTimeAccessCode" pInputText formControlName="oneTimeAccessCode" maxlength="10"
                                    (keydown)="preventSpaces($event)" placeholder="Enter new access code" />
                                <div
                                    *ngIf="parkingForm.get('oneTimeAccessCode')?.hasError('required')  && (parkingForm.get('oneTimeAccessCode')?.dirty || parkingForm.get('oneTimeAccessCode')?.touched)">
                                    <div class="validation-error"> This field is required*</div>
                                </div>
                                <div
                                    *ngIf="parkingForm.get('oneTimeAccessCode').hasError('minlength') && !parkingForm.get('oneTimeAccessCode').hasError('pattern')">
                                    <div class="validation-error">Min. 2 character are required.</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="inner-label">
                                <label for="monthlyAccessCode">Monthly access code</label>
                                <input id="monthlyAccessCode" pInputText formControlName="monthlyAccessCode" maxlength="10"
                                    (keydown)="preventSpaces($event)" placeholder="Enter new access code" />
                                <div
                                    *ngIf="parkingForm.get('monthlyAccessCode')?.hasError('required')  && (parkingForm.get('monthlyAccessCode')?.dirty || parkingForm.get('monthlyAccessCode')?.touched)">
                                    <div class="validation-error"> This field is required*</div>
                                </div>
                                <div
                                    *ngIf="parkingForm.get('monthlyAccessCode').hasError('minlength') && !parkingForm.get('monthlyAccessCode').hasError('pattern')">
                                    <div class="validation-error">Min. 2 digits are required.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="divider">
            </div>

            <div class="grid form-deatail">

                <div class="field col-12">
                    <div class="custom-flex-start">
                        <h5 class="park-heading">Amenities</h5>
                        <div class="p-checkbox-row facility-outer">
                            <ul>
                                <li *ngFor="let facility of facilitiesList">
                                    <p-checkbox name="group1" (onChange)="addFacilityId(facility.id)"
                                        [value]="facility.facilityName" [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="selectedFacilities" [inputId]="facility.id" id="facility">
                                    </p-checkbox>
                                    <label for="facility">{{ facility.facilityName }}</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="divider">
            </div>
            <div formArrayName="truckTypeArray">
                <div *ngFor="let truckGroup of truckTypeArray.controls; let i = index" [formGroupName]="i"
                    class="half-length">
                    <div class="spot-outer">
                        <div class="half-text">
                            <h4>Spot Type - <span *ngIf="spotTypes[i]?.vehicleName .includes('Full-Length')">Full
                                    Length</span>
                                <span *ngIf="!spotTypes[i]?.vehicleName.includes('Full-Length')">Half Length</span>
                            </h4>
                            <app-tooltip [tooltipMessage]="spotTypes[i]?.description"
                                [addClass]="'custom-tooltip-width'"></app-tooltip>
                        </div>
                        <div class="add-special add-morebtn rate-outer">
                            <p class="regular-rate">To add a special rate, you must first add a regular rate.</p>
                            <p-button label="Add Special Rate" icon="pi pi-plus" [disabled]="isSpecialRateEnabled(i)"
                                (onClick)="openCustomRates(spotTypes[i]?.vehicleTypeId)" iconPos="right">
                            </p-button>
                        </div>
                    </div>
                    <div class="public-rate">
                        <div class="grid public-padding">
                            <div class="custom-flex-start md:col-3 custom-spacing-lright">
                                <label for="dailyRate-{{ i }}">Daily Public Rate <span
                                        class="custom-star">*</span></label>
                                <input pInputText inputmode="decimal"
                                    (keypress)="onKeyPressAllowTwoDigitAfterPoint($event)" id="dailyRate-{{ i }}"
                                    aria-describedby="username-help" placeholder="Enter Daily Charges"
                                    formControlName="dailyRate" maxlength="8" />
                                <div *ngIf="truckGroup.get('dailyRate')?.hasError('required') &&
                                (truckGroup.get('dailyRate')?.dirty || truckGroup.get('dailyRate')?.touched)">
                                    <div class="validation-error">This field is required*</div>
                                </div>
                                <div *ngIf="truckGroup.get('dailyRate')?.hasError('lessThanZero') &&
                                (truckGroup.get('dailyRate')?.value !== null && truckGroup.get('dailyRate')?.value !== '') &&
                                (truckGroup.get('dailyRate')?.dirty || truckGroup.get('dailyRate')?.touched)">
                                    <div class="validation-error">Charge must be greater than 0*</div>
                                </div>
                            </div>
                            <div class="custom-flex-start md:col-3 custom-spacing-lright">
                                <label for="monthlyRate-{{ i }}">Monthly Public Rate <span
                                        class="custom-star">*</span></label>
                                <input pInputText inputmode="decimal"
                                    (keypress)="onKeyPressAllowTwoDigitAfterPoint($event)" id="monthlyRate-{{ i }}"
                                    aria-describedby="username-help" placeholder="Enter Monthly Charges"
                                    formControlName="monthlyRate" maxlength="8" />
                                <div *ngIf="truckGroup.get('monthlyRate')?.hasError('required') &&
                                    (truckGroup.get('monthlyRate')?.dirty || truckGroup.get('monthlyRate')?.touched)">
                                    <div class="validation-error">This field is required*</div>
                                </div>
                                <div *ngIf="truckGroup.get('monthlyRate')?.hasError('lessThanZero') &&
                                    (truckGroup.get('monthlyRate')?.value !== null && truckGroup.get('monthlyRate')?.value !== '') &&
                                    (truckGroup.get('monthlyRate')?.dirty || truckGroup.get('monthlyRate')?.touched)">
                                    <div class="validation-error">Charge must be greater than 0*</div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="getRatesBySpotTypeId(spotTypes[i]?.vehicleTypeId)?.length > 0" class="half-table">
                            <p-table [value]="getRatesBySpotTypeId(spotTypes[i]?.vehicleTypeId)"
                                responsiveLayout="scroll">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th scope="col">Code</th>
                                        <th scope="col">Daily Rate ($)</th>
                                        <th scope="col">Monthly Rate ($)</th>
                                        <th scope="col" class="custom-description">Description</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-record>
                                    <tr>
                                        <td>
                                            <p class="common-style">{{ record.code }}</p>
                                        </td>
                                        <td>
                                            <p class="common-style">{{ record.dailyRate }}</p>
                                        </td>
                                        <td>
                                            <p class="common-style">{{ record.monthlyRate }}</p>
                                        </td>
                                        <td>
                                            <div class="long-description">
                                                <p class="common-style">{{ record.description }}</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="three-dot">
                                                <img (click)="activeItem = record; showData(record, $event); menu.toggle($event);"
                                                    src="assets/images/dashboard-dot.svg" alt="" />
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>

                </div>
            </div>

            <div class="form-deatail">
                <div class="divider">
                </div>
                <div class="upload-outer">
                    <label>Upload Parking Photo</label>
                    <div class="grid">
                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="add-image custom-addimg">
                                <p-fileUpload #fileUpload mode="basic" name="demo[]" (onSelect)="uploadImage1($event)"
                                    [auto]="true" chooseLabel="Add Image"></p-fileUpload>
                                <div *ngIf="btn1" class="img-overlap"
                                    [ngStyle]="{ 'background-image': 'url(' + imageUrl1 + ')' }">
                                    <ul>
                                        <li>
                                            <img src="assets/images/img-delete.svg" alt="" (click)="del1(imageUrl1)" />
                                        </li>
                                        <li>
                                            <img src="assets/images/img-view.svg" alt=""
                                                (click)="showDialog(imageUrl1)" />
                                        </li>
                                    </ul>
                                </div>
                                <div *ngIf="isImgError1">
                                    <div class="validation-error">File size should be less than 5MB.</div>
                                </div>
                            </div>

                        </div>
                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="add-image">
                                <p-fileUpload #fileUpload1 mode="basic" name="demo[]" (onSelect)="uploadImage2($event)"
                                    [auto]="true" chooseLabel="Add Image"></p-fileUpload>
                                <div *ngIf="btn2" class="img-overlap"
                                    [style.background-image]="'url(' + imageUrl2 + ')'">
                                    <ul>
                                        <li>
                                            <img src="assets/images/img-delete.svg" alt="" (click)="del2(imageUrl2)" />
                                        </li>
                                        <li>
                                            <img src="assets/images/img-view.svg" alt=""
                                                (click)="showDialog(imageUrl2)" />
                                        </li>
                                    </ul>
                                </div>
                                <div *ngIf="isImgError2">
                                    <div class="validation-error">File size should be less than 5MB.</div>
                                </div>
                            </div>

                        </div>
                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="add-image">
                                <p-fileUpload #fileUpload2 mode="basic" name="demo[]" (onSelect)="uploadImage3($event)"
                                    [auto]="true" chooseLabel="Add Image"></p-fileUpload>
                                <div *ngIf="btn3" class="img-overlap"
                                    [style.background-image]="'url(' + imageUrl3 + ')'">
                                    <ul>
                                        <li>
                                            <img src="assets/images/img-delete.svg" alt="" (click)="del3(imageUrl3)" />
                                        </li>
                                        <li>
                                            <img src="assets/images/img-view.svg" alt=""
                                                (click)="showDialog(imageUrl3)" />
                                        </li>
                                    </ul>
                                </div>
                                <div *ngIf="isImgError3">
                                    <div class="validation-error">File size should be less than 5MB.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="slotsAvailable?.length > 0 || (isParkAnywhere === true)">
                    <div class="divider">
                    </div>
                    <div class="under-maintance">
                        <h5>Under Maintenance</h5>

                        <div class="grid startdate">
                            <div class="col-12 lg:col-6 no-padding">
                                <h4>Start Date and Time</h4>
                                <div class="grid custom-width">
                                    <div class="col-6 lg:col-6 custom-spacing-right">
                                        <div class="date-input custom-icon">
                                            <p-calendar [showIcon]="false" formControlName="startDate"
                                                placeholder="Select Date" [minDate]="minDate"
                                                (onSelect)="generateHourOptions($event)"></p-calendar>
                                            <img src="../../../../assets/images/date-calender.png" alt="calender" />
                                        </div>
                                    </div>
                                    <div class="col-6 lg:col-6 custom-spacing-lright">
                                        <div class="date-input custom-icon common-time">
                                            <p-dropdown class="custom-dropdown" #timedropdownRef
                                                [options]="getHoursValue" placeholder="Select Time" optionLabel="label"
                                                optionValue="value" formControlName="startTime">
                                                <ng-template let-option pTemplate="item">
                                                    <span [ngClass]="{'disabled-option': option.disabled}">{{
                                                        option.label
                                                        }}</span>
                                                </ng-template>
                                            </p-dropdown>
                                            <img src="../../../../assets/images/time-icon.png" alt="time" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 lg:col-6 no-padding">
                                <h4>End Date and Time</h4>
                                <div class="grid custom-width">
                                    <div class="col-6 lg:col-6 custom-spacing-right">
                                        <div class="date-input custom-icon">
                                            <p-calendar [showIcon]="false" formControlName="endDate"
                                                placeholder="Select Date" [minDate]="minDate"
                                                (onSelect)="generateHourOptions($event)"></p-calendar>
                                            <img src="../../../../assets/images/date-calender.png" alt="calender" />
                                        </div>
                                    </div>
                                    <div class="col-6 lg:col-6 custom-spacing-lright no-padding">
                                        <div class="date-input custom-icon common-time">
                                            <p-dropdown class="custom-dropdown" #timedropdownRef
                                                [options]="getHoursValue" placeholder="Select Time" optionLabel="label"
                                                optionValue="value" formControlName="endTime">
                                                <ng-template let-option pTemplate="item">
                                                    <span [ngClass]="{'disabled-option': option.disabled}">{{
                                                        option.label
                                                        }}</span>
                                                </ng-template>
                                            </p-dropdown>
                                            <img src="../../../../assets/images/time-icon.png" alt="time" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="formgrid grid">
                            <div class="field col-12 md:col-6 lg:col-6">
                                <div class="custom-flex-start gap-2">
                                    <div
                                        class="lg:flex md:flex-row  sm:flex-column gap-1 lg:pt-3 sm:pt-0 p-checkbox-row align-items-center">
                                        <div class="common-flex-center gap-1 mr-2 lg:mt-0 sm:mt-2"
                                            *ngFor="let main of entireParkingMaintanceList">
                                            <p-radioButton [inputId]="main.value" [value]="main.value"
                                                formControlName="isEntireParkingUnderMaintenance"
                                                (onClick)="entireParkingMaintance(main.value)"></p-radioButton>
                                            <label>{{main.name}}</label>
                                        </div>
                                        <label for="isEntireParkingUnderMaintenance">Select Entire Parking?</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="grid parking-maintance" *ngIf="isParkAnywhere==false">
                            <div class="field col-12 md:col-3 lg:col-3">
                                <h4>Select spots to put under maintenace </h4>
                                <div *ngIf="maintenanceslots.length > 0" class="field">
                                    <p-multiSelect [disabled]="isEntireParkingNotAvaliable" [options]="maintenanceslots"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedSlots"
                                        placeholder="Select Spots" [displaySelectedLabel]="false"
                                        optionLabel="slotName">
                                    </p-multiSelect>
                                </div>
                                <div *ngIf="noSlotSelected   && selectedSlots.length===0; else slots_list"
                                    class="field">
                                    <p>Currently no slot is under maintenance</p>
                                </div>
                                <ng-template #slots_list>
                                    <div class="search-slotnumber">
                                        <ul>
                                            <li *ngFor="let slot of selectedSlots" class="selected-item">
                                                <p> {{slot.slotName}} </p>
                                            </li>
                                        </ul>
                                    </div>
                                </ng-template>

                            </div>
                        </div>
                        <div class="grid parking-maintance" *ngIf="isParkAnywhere==true">
                            <div class="field col-12 md:col-3 lg:col-3">
                                <h4>Spaces to put under maintenance</h4>
                                <div>
                                    <input type="text" [disabled]="isEntireParkingNotAvaliable"
                                        formControlName="spaceUnderMaintenance" pInputText placeholder=""
                                        (input)="checkMaxSlots($event)" />
                                    <div *ngIf="isParkingCapacityError">
                                        <div class="validation-error">Number of spaces cannot be greater than Total
                                            Capacity of
                                            ({{totalNumberOfSlots}}).</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid next-btn">
                <p-button label="Next" (onClick)="nextPage(parkingForm)" class="ml-auto"></p-button>
            </div>
        </form>
        <form class="upcoming-soon" *ngIf="isComingsoonParking" [formGroup]="parkingUpcomingForm">
            <div class="grid">
                <div class="field col-12 md:col-6 lg:col-6 custom-spacing-right pb-0">
                    <div class="custom-flex-start formgrid">
                        <label for="comingSoonParkingName">Parking Name <span class="custom-star">*</span></label>
                        <input pInputText placeholder="Type Parking Name" (keydown)="preventFirstSpace($event)"
                            id="comingSoonParkingName" aria-describedby="username-help" formControlName="name" />
                        <div
                            *ngIf="parkingUpcomingForm.get('name')?.hasError('required')  && (parkingUpcomingForm.get('name')?.dirty || parkingUpcomingForm.get('name')?.touched)">
                            <div class="validation-error">This field is required*</div>
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-6 lg:col-6 custom-spacing-lright pb-0">
                    <div class="custom-flex-start formgrid parking-location">
                        <label for="comingSoonLocAddress">Parking Location <span class="custom-star">*</span></label>
                        <div class="p-inputgroup">
                            <input id="comingSoonLocAddress" type="text" pInputText placeholder="Set Location on Map"
                                (keydown)="preventFirstSpace($event)" formControlName="locAddress" mapAutoComplete
                                (mapSearch)="searchAutoCompleteLocation($event, 'parkingUpcoming')" />
                            <button class="send-btn" type="button"
                                (click)="openMap(parkingUpcomingForm, 'locAddress', 'location')" pButton
                                icon="pi pi-send" styleClass="p-button-warn"></button>
                        </div>
                        <div
                            *ngIf="parkingUpcomingForm.get('locAddress')?.hasError('required')  && (parkingUpcomingForm.get('locAddress')?.dirty || parkingUpcomingForm.get('locAddress')?.touched)">
                            <div class="validation-error"> This field is required*</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="grid next-btn">
                <div class="field col common-flex-center">
                    <p-button label="Update" (onClick)="updateComingsoon(parkingUpcomingForm)"
                        class="ml-auto"></p-button>
                </div>
            </div>
        </form>
    </div>
</div>
<div class="img-pre custom-preimg upload-model" *ngIf="imagePreview">
    <p-dialog header="Header" [(visible)]="visible" [modal]="true" [style]="{ width: '75vw' }" [draggable]="false"
        [resizable]="false" (click)="onDialogHide()">
        <div class="image-cross">
            <img src="assets/images/export-close.svg" alt="Close">
        </div>
        <img [src]="imageLinkForPreview" class="preview-image" alt="preview" />
    </p-dialog>
</div>
<div class="custom-export"> <p-menu #menu [model]="items" [popup]="true"></p-menu>
</div>